import http from 'plugins/axios';

export default {
    getList(data) {
        return http.get({
            url: '/admin/community/list',
            data
        });
    },
    addCommunity(data) {
        return http.post({
            url: '/admin/community/create',
            data,
            dataType: 'form'
        })
    },
    updateCommunity(data) {
        return http.post({
            url: '/admin/community/update',
            data,
            dataType: 'form'
        })
    },
    deleteCommunity(data) {
        return http.post({
            url: '/admin/community/delete',
            data,
            dataType: 'form'
        })
    }
}